import { CaretDownOutlined, CaretRightOutlined } from '@ant-design/icons';
import { Button, Checkbox, Tree } from 'antd';
import { useEffect, useState } from 'react';

import CrossButton from '../../assets/CrossButton.svg';
import { contradictionColors, LOADING } from '../../Constants/commonConstants';

const compareOptions = [
  {
    title: <p className='fs-12 definitionTag tag-outline'>ALL DOCUMENTS</p>,
    key: 'ALL_DOCUMENTS',
    isLeaf: true,
    children: [
      {
        title: <p className='fs-12'>Deviations</p>,
        key: 'Deviation',
      },
      {
        title: <p className='fs-12'>Identical</p>,
        key: 'Identical',
      },
      {
        title: <p className='fs-12'>Missing</p>,
        key: 'Missing',
      },
    ],
  },
  // {
  //   label: <p className="fs-12 definitionTag tag-outline">DEFINITIONS</p>,
  //   value: 'DEFINITIONS',
  // },
  // {
  //   label: <p className="fs-12 amountsTag tag-outline">AMOUNTS AND NUMBERS</p>,
  //   value: 'AMOUNTS_AND_NUMBERS',
  // },
  // {
  //   label: <p className="fs-12 datesTag tag-outline">DATES</p>,
  //   value: 'DATES',
  // },
  // {
  //   label: <p className="fs-12 clauseRefTag tag-outline">CLAUSE REFERENCES</p>,
  //   value: 'CLAUSE_REFERENCES',
  // },
  // {
  //   label: <p className="fs-12 placeholderTag  tag-outline">PLACEHOLDER</p>,
  //   value: 'PLACEHOLDERS',
  // },
  // {
  //   label: <p className="fs-12 uncategorisedTag tag-outline">UNCATEGORISED</p>,
  //   value: 'null',
  // },
];

// const typeOption = [
//   {
//     label: <p className="fs-12 success-tag tag-outline">INSERTED</p>,
//     value: 'inserted',
//   },
//   {
//     label: <p className="fs-12 danger-tag tag-outline">DELETED</p>,
//     value: 'deleted',
//   },
//   {
//     label: <p className="fs-12 warning-tag tag-outline">MODIFIED</p>,
//     value: 'replaced',
//   },
// ];

const CompareFilters = ({
  isFilterOpen,
  setIsFilterOpen,
  setTotalRegionPages,
  checkBoxDetails,
  filterRef,
  reAnlysisng,
  files,
  setFilter,
}) => {
  const [isCompareOpen, setIsCompareOpen] = useState(true);
  const [isContradictOpen, setIsContradictOpen] = useState(true);
  const [contradictCheckValues, setContradictCheckValues] = useState([]);
  const [compareCheckValues, setCompareCheckValues] = useState([]);
  const [loadingFilter, setLoadingFilter] = useState(false);
  const [tempDataFilters, setTempDataFilters] = useState({
    compare: [],
    contradict: [],
  });
  const [activeFilters, setActiveFilters] = useState([]);
  const [isApplyFilterDisable, setIsApplyFilterDisable] = useState(false);
  const [isClearBtnDisable, setIsClearBtnDisable] = useState(false);
  const [isClearLoading, setIsClearLoading] = useState(false);
  const [isClearClicked, setIsClearClicked] = useState(false);
  const filesIndexMapping = files.reduce((acc, f, i) => ({ ...acc, [f.file_name]: i }), {});
  const contradictOption = files?.map((f) => ({
    label: (
      <p
        className='fs-12 tag-outline'
        style={{
          color: contradictionColors[filesIndexMapping[f?.file_name]]?.textColor,
          background: contradictionColors[filesIndexMapping[f?.file_name]]?.backgroundColor,
        }}
      >
        {f?.file_name}
      </p>
    ),
    value: f?.file_name,
  }));

  useEffect(() => {
    setCompareCheckValues(tempDataFilters.compare);
    setContradictCheckValues(tempDataFilters.contradict);
  }, [isFilterOpen]);

  useEffect(() => {
    if (reAnlysisng === LOADING) {
      clearFiltersHandler();
    }
  }, []);

  useEffect(() => {
    if (isClearClicked && compareCheckValues.length === 0 && contradictCheckValues.length === 0) {
      submitButtonHandler(setIsClearLoading);
    }
  }, [isClearClicked]);

  useEffect(() => {
    setIsApplyFilterDisable(
      [...compareCheckValues, ...contradictCheckValues].every((item) =>
        activeFilters?.includes(item)
      ) &&
        JSON.stringify([...compareCheckValues, ...contradictCheckValues].sort()) ===
          JSON.stringify(activeFilters.sort())
    );
    setIsClearBtnDisable([...compareCheckValues, ...contradictCheckValues].length === 0);
  }, [compareCheckValues, contradictCheckValues, isFilterOpen]);

  const dropdownClickHandler = (type) => {
    if (type === 'Compare') {
      setIsCompareOpen(!isCompareOpen);
    } else if (type === 'Contradict') {
      setIsContradictOpen(!isContradictOpen);
    }
  };

  const onCheckBoxValueChange = (type, checkedValues) => {
    if (type === 'Contradict') {
      setContradictCheckValues(checkedValues);
    } else {
      setCompareCheckValues(checkedValues);
    }
  };

  const submitButtonHandler = (setFilterLoader) => {
    setFilterLoader(true);
    setTotalRegionPages({
      leftRegion: checkBoxDetails.originalTotalPage,
      rightRegion: checkBoxDetails.modifiedTotalPage,
      singleRegion: checkBoxDetails.singleViewTotalPage,
    });

    if (
      !isClearClicked &&
      (compareCheckValues?.length !== 0 || contradictCheckValues?.length > 0)
    ) {
      setFilter((prev) => ({
        ...prev,
        showComparison: compareCheckValues,
        showContradiction: contradictCheckValues,
        isActive: true,
      }));
    } else {
      setFilter({
        showComparison: ['ALL_DOCUMENTS'],
        showContradiction: files?.map((f) => f.file_name),
        showBookmark: false,
        isActive: false,
      });
    }

    // let length;
    // if (checkValues?.length !== 0 && typeCheckValues.length !== 0) {
    //   const filteredData = compareData.filter((item) => {
    //     return (
    //       checkValues.includes(
    //         item.category === null ? 'null' : item.category,
    //       ) && typeCheckValues.includes(item.kind)
    //     );
    //   });
    //   length = filteredData.length;
    //   setAllCardData(filteredData);
    // } else if (checkValues?.length !== 0 && typeCheckValues?.length === 0) {
    //   const filteredData = compareData.filter((item) => {
    //     return checkValues.includes(
    //       item.category === null ? 'null' : item.category,
    //     );
    //   });
    //   length = filteredData.length;
    //   setAllCardData(filteredData);
    // } else if (typeCheckValues.length !== 0 && checkValues?.length === 0) {
    //   const filteredData = compareData.filter((item) => {
    //     return typeCheckValues.includes(item.kind);
    //   });
    //   length = filteredData.length;
    //   setAllCardData(filteredData);
    // } else {
    //   setAllCardData(compareData);
    //   length = compareData?.length;
    // }
    setTempDataFilters({
      ...tempDataFilters,
      contradict: contradictCheckValues,
      compare: compareCheckValues,
    });
    setActiveFilters([...contradictCheckValues, ...compareCheckValues]);
    setTimeout(() => {
      setFilterLoader(false);
      // setTotalCardCount(length);
      setIsFilterOpen(!isFilterOpen);
      setIsClearClicked(false);
    }, 500);
  };

  const clearFiltersHandler = () => {
    setCompareCheckValues([]);
    setContradictCheckValues([]);
    setIsClearClicked(true);
  };

  return (
    <div className='filter-modal-container '>
      {isFilterOpen && (
        <div className='compare-filter-dropdown' ref={filterRef}>
          <div className='filter-modal-container compare-tour-step-2'>
            <div className='filter-header'>
              <div>Filters</div>
              <img
                src={CrossButton}
                alt='Cross Button'
                className='title-rename-logo'
                onClick={() => {
                  setIsFilterOpen(!isFilterOpen);
                }}
              />
            </div>
            <div className='filter-category'>
              <div
                className='category-dd'
                role='button'
                onClick={(e) => {
                  e.stopPropagation();
                  dropdownClickHandler('Compare');
                }}
              >
                {isCompareOpen ? <CaretDownOutlined /> : <CaretRightOutlined />} Compare Across
              </div>

              <div id='expand-container'>
                <div id='expand-filter' className={isCompareOpen ? 'expanded' : ''}>
                  {isCompareOpen && (
                    <div>
                      <Tree
                        checkable
                        autoExpandParent
                        selectable={false}
                        onCheck={(e) => onCheckBoxValueChange('Category', e)}
                        checkedKeys={compareCheckValues}
                        treeData={compareOptions}
                        defaultExpandAll
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className='filter-type'>
              <div
                className='category-dd'
                role='button'
                onClick={(e) => {
                  e.stopPropagation();
                  dropdownClickHandler('Contradict');
                }}
              >
                {isContradictOpen ? <CaretDownOutlined /> : <CaretRightOutlined />} View Internal
                Contradictions
              </div>
              <div id='expand-container'>
                <div id='expand-filter' className={isContradictOpen ? 'expanded' : ''}>
                  {isContradictOpen && (
                    <div>
                      <Checkbox.Group
                        value={contradictCheckValues}
                        options={contradictOption}
                        onChange={(e) => onCheckBoxValueChange('Contradict', e)}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className='filter-footer'>
              <Button
                onClick={clearFiltersHandler}
                disabled={isClearBtnDisable}
                loading={isClearLoading}
              >
                Reset
              </Button>

              <Button
                type='primary'
                onClick={() => submitButtonHandler(setLoadingFilter)}
                loading={loadingFilter}
                disabled={isApplyFilterDisable}
              >
                {loadingFilter ? 'Applying' : 'Apply Filter'}
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompareFilters;
